import React from 'react';

// styles
import {
    StepContainer,
    StepIndicator,
    StepHeader,
    StepTitle,
    StepDescription,
    CardFlow,
    DemoCard,
    DemoCardContent,
    CardImageContainer,
    CardImage,
    LockOverlay,
    LockIconImg,
    LockIconSmall,
    CardLabel,
    CardDetails,
    UnlockButton,
    OpenButton,
    FlowArrow,
    ArrowIcon,
    TokenIcon
} from './StepOne.styles.js';

// assets
import lockIcon from '../../../../assets/system/icons/lock-icon.svg';
import tokenIcon from '../../../../assets/system/icons/pullvault-token.png';
import checklistGif from '../../../../assets/landing/unlocked.gif';

export default function StepOne() {
    return (
        <StepContainer>
            <StepIndicator>1</StepIndicator>
            <StepHeader>
                <StepTitle>Track your cards</StepTitle>
                <StepDescription>Use tokens to unlock checklists</StepDescription>
            </StepHeader>
            <CardFlow>
                <DemoCard $isUnlocked={false}>
                    <DemoCardContent>
                        <CardImageContainer>
                            <CardImage src={checklistGif} alt="Locked checklist" $isLocked />
                            <LockOverlay>
                                <LockIconImg src={lockIcon} alt="Locked" />
                            </LockOverlay>
                        </CardImageContainer>
                        <CardLabel>
                            <h3>2025 Topps Chrome Baseball</h3>
                        </CardLabel>
                        <CardDetails>
                            <UnlockButton>
                                <h4>UNLOCK</h4>
                                <LockIconSmall src={lockIcon} alt="" />
                            </UnlockButton>
                        </CardDetails>
                    </DemoCardContent>
                </DemoCard>
                <FlowArrow>
                    <TokenIcon src={tokenIcon} alt="Token" />
                    <ArrowIcon>→</ArrowIcon>
                </FlowArrow>
                <DemoCard $isUnlocked>
                    <DemoCardContent>
                        <CardImageContainer>
                            <CardImage src={checklistGif} alt="Unlocked checklist" $isLocked={false} />
                        </CardImageContainer>
                        <CardLabel>
                            <h3>2025 Topps Chrome Baseball</h3>
                        </CardLabel>
                        <CardDetails>
                            <OpenButton>
                                <h4>OPEN</h4>
                            </OpenButton>
                        </CardDetails>
                    </DemoCardContent>
                </DemoCard>
            </CardFlow>
        </StepContainer>
    );
}
